import siders from './siders.json';
import meetingRooms from './meetingRooms.json';
import modal from './modal.json';
import spaceBooking from './spaceBooking.json';
import workplaceService from './workplaceService.json';
var itTranslations = {
    siders: siders,
    meetingRooms: meetingRooms,
    modal: modal,
    spaceBooking: spaceBooking,
    workplaceService: workplaceService,
};
export default itTranslations;
